window.addEventListener("load", function () {
  // Khởi tạo Swiper với cấu hình hiển thị một phần slide tiếp theo
  const swiperFeature = new Swiper(".swiperFeature", {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    loop: true,
    effect: "coverflow",
    coverflowEffect: {
      rotate: 0,
      stretch: 450,
      depth: 300,
      slideShadows: true,
    },
    breakpoints: {
      751: {
        slidesPerView: "auto",
        coverflowEffect: {
          stretch: 475,
        },
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});
